/*****************************************************
 * Packages
 ******************************************************/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

/*****************************************************
 * Locals
 ******************************************************/
import { prefix_bcs } from '../../../config';
import { Link } from 'react-router-dom';

const controlIcons = [
    {
        icon: ['far', 'arrows-alt'],
        title: 'Move / Drag & Drop',
    },
    {
        icon: ['far', 'edit'],
        title: 'Setting / All Styles Editing Panel',
    },
    {
        icon: ['far', 'clone'],
        title: 'Duplicate',
    },
    {
        icon: ['far', 'save'],
        title: 'Save to Library',
    },
    {
        icon: ['far', 'trash-alt'],
        title: 'Delete Any Element',
    },
    {
        icon: ['far', 'layer-plus'],
        title: 'Add New / Expend',
    },
];

const quickStartGuide = [
    {
        title: 'Builder Basics',
        url:
            'https://help.dorik.io/site-building-customization/builder-structure-basics',
    },
    {
        title: 'Typography & Global Styles',
        url:
            'https://help.dorik.io/site-building-customization/setting-up-typography-global-styles',
    },
    {
        title: 'Add New Rows and Columns',
        url:
            'https://help.dorik.io/site-building-customization/add-new-row-and-column-inside-section',
    },
    {
        title: 'Add New Element',
        url:
            'https://help.dorik.io/site-building-customization/add-new-element',
    },
    {
        title: 'Common Styles',
        url: 'https://help.dorik.io/style-and-editing/common-styles',
    },
    {
        title: 'Elements Guide',
        url: 'https://help.dorik.io/style-and-editing/elements',
    },
    {
        title: 'Responsive Design',
        url: 'https://help.dorik.io/style-and-editing/responsive-design',
    },
];

function EmptySection({ children }) {
    return (
        <div className={`${prefix_bcs} ${prefix_bcs}__empty-section`}>
            <h2 className={`${prefix_bcs}__empty-section-title-text`}>
                Get Started by Adding New Section
            </h2>
            <p className="mt-0 mb-40">
                Start designing by adding <strong>Section, Columns</strong>{' '}
                (with Container) and <strong>Elements</strong>
            </p>
            {children}

            <hr className={`${prefix_bcs}__empty-section-line`} />
            <div className={`${prefix_bcs}__empty-section-guide`}>
                <div>
                    <h4>Control Icons</h4>
                    <ul
                        className={`${prefix_bcs}__ul-normalize ${prefix_bcs}__ul-list`}
                    >
                        {controlIcons.map((ctrl, idx) => (
                            <li key={idx}>
                                <FontAwesomeIcon
                                    fixedWidth
                                    icon={ctrl.icon}
                                    className="icon"
                                />{' '}
                                {ctrl.title}
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4>Quick Start Guide</h4>
                    <ul
                        className={`${prefix_bcs}__ul-normalize ${prefix_bcs}__ul-list`}
                    >
                        {quickStartGuide.map((guide, idx) => (
                            <li key={idx}>
                                <a
                                    href={guide.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon
                                        fixedWidth
                                        className="icon"
                                        icon={['far', 'chevron-right']}
                                    />{' '}
                                    {guide.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4>Builder Structure</h4>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://help.dorik.io/site-building-customization/builder-structure-basics"
                    >
                        <img
                            src="/assets/images/builder-component-help.png"
                            alt="Dorik Builder Controls"
                        />
                    </a>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'block',
                            textAlign: 'center',
                            textDecoration: 'none',
                        }}
                        href="https://help.dorik.io/site-building-customization/builder-structure-basics"
                    >
                        View in Documentation
                    </a>
                </div>
            </div>
        </div>
    );
}

export default EmptySection;
